import { lazy } from "react";

// project-imports
import Loadable from "components/Loadable";

/**
 * Lazy-loaded component for rendering the list of Redbird.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} ListRedbirdPage - Lazy-loaded ListProductPage component.
 */
const ListRedbirdPage = Loadable(lazy(() => import("./ListRedbirdPage")));

/**
 * Lazy-loaded component for rendering the add Product page.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} AddProductPage - Lazy-loaded AddProductPage component.
 */
const AddRedbirdPage = Loadable(lazy(() => import("./AddRedbirdPage")));

/**
 * Lazy-loaded component for rendering the View Product page.
 * @constant {LazyExoticComponent<React.ComponentType<any>>} ViewProductPage - Lazy-loaded ViewProductPage component.
 */
const EditRedbirdPage = Loadable(lazy(() => import("./EditRedbirdPage")));

/**
 * Array containing route definitions for the Product-related pages.
 * @constant {Object[]} ProductRoutes - Array of Product route objects.
 * @property {string} ProductRoutes[].path - The path of the Product route.
 * @property {React.ReactElement} ProductRoutes[].element - The React element to be rendered for the Product route.
 */
const ProductRoutes = [
  {
    path: "list",
    element: <ListRedbirdPage />,
  },
  {
    path: "add",
    element: <AddRedbirdPage />,
  },
  {
    path: "edit/:redbird_id",
    element: <EditRedbirdPage />,
  },
];

export default ProductRoutes;
